import React, { useEffect, useState } from 'react';

import checkIcon from '_images/lead-page-check-icon.svg';

import { Col, Row } from 'antd';

const LeadPageTabSlider = ({ id, title, data, imgSize }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const handleClickTab = (i) => {
    setSelectedTabIndex(i);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSelectedTabIndex(
        selectedTabIndex === data.length - 1 ? 0 : selectedTabIndex + 1
      );
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="lead-page-large-section pt-16 pb-16" id={id}>
      <h2 className="text-center leading-snug">{title}</h2>
      <Row className="mt-8">
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <div className="hidden lg:block">
            {data.map((t, i) => (
              <div
                key={i}
                onClick={() => handleClickTab(i)}
                className="mt-5 cursor-pointer"
              >
                <h3
                  className="font-semibold mb-1"
                  style={{ color: selectedTabIndex === i ? '#ff2636' : '#000' }}
                >
                  {t.label}
                </h3>
                <div className="os-text-18">{t.description}</div>
              </div>
            ))}
          </div>
          <div className="pr-4 pl-4 lg:hidden">
            {data.map((t, i) => (
              <div className="mt-5" key={i}>
                <h3 className="font-semibold flex justify-start items-start gap-2">
                  <img
                    src={checkIcon}
                    width="22"
                    alt={t.label}
                    className="mt-2 lead-page-check-icon"
                    loading="lazy"
                  />
                  <span className="leading-snug">{t.label}</span>
                </h3>
                <div className="os-text-18">{t.description}</div>
              </div>
            ))}
          </div>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <div className="hidden lg:block">
            {data.map((t, i) => (
              <div
                key={i}
                className="mt-4 "
                style={{ display: selectedTabIndex === i ? 'block' : 'none' }}
              >
                <img
                  className="mx-auto"
                  alt={t.label}
                  width={imgSize?.width || 512}
                  height={imgSize?.height || 384}
                  src={t.image}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LeadPageTabSlider;
